import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import dt from '../../../shared/theme';
import StatisticsGroup from '../tools-components/statistics-group';
import Ul from '../tools-components/common-styles';
import Like from '../tools-components/like';
import Comment from '../tools-components/comment';
import getWireStatistics from '../../../services/wire/statistics-services';

const Container = styled.aside`
  display: flex;
  position: inherit;
  max-height: 54px;
  flex-direction: row;
  align-items: flex-end;
  margin-right: -15px;

  hr.wire-splitter-hr {
    flex: 1;
    margin: auto 0 10px 0;
    border-width: 0;
    border-bottom: 1px solid ${props => dt(props).theme.secondaryColorLight};
  }

  &&&& > ul {
    ${Ul};
    line-height: unset;
    flex: 0;
    flex-direction: row;
    li {
      float: left;
      margin-right: 16px;

      > span.comment-button > span.count {
        display: flex;
        justify-content: center;
      }

      a {
        span {
          top: 0;
        }
      }
    }
  }

  &&&& > .--statistics {
    display: inline-flex;
    align-items: center;
    > li {
      display: inline-flex;
      align-items: center;
      float: unset;
      span {
        font-weight: normal;
        white-space: nowrap;
      }

      .count {
        font-weight: bold;
        margin-left: .5em;
      }
    }
  }

  &&&& > .--engage {
    float: right;
    margin-left: 16px;

    > li {
      display: flex;
      flex-direction: column;

      span.icon-lw {
        font-size: 30px;
      }
    }
  }
`;

export default function WireToolsHorizontal({ wireId, showStatistics }) {
  const [wire, setWire] = React.useState(null);

  React.useEffect(() => {
    getWireStatistics(wireId).then(({ data }) => setWire(data));
  }, [wireId]);

  return (
    <Container className="wire-tools --inline">
      {!!wire && !!showStatistics && <StatisticsGroup wire={wire} />}
      {!!wire && (
        <>
          <hr className="wire-splitter-hr" />
          <ul className="--engage">
            <li><Like wire={wire} /></li>
            <li><Comment wire={wire} /></li>
          </ul>
        </>
      )}
    </Container>
  );
}

WireToolsHorizontal.propTypes = {
  wireId: PropTypes.number.isRequired,
  showStatistics: PropTypes.bool.isRequired,
};
